import classNames from 'classnames';
import React from 'react';
import _uniqueId from 'lodash/uniqueId';

export interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  className?: string;

  /**
   * テキストラベル
   */
  label?: React.ReactNode;

  /**
   * テキストラベルのクラス名
   */
  labelClassName?: string;

  /**
   * 無効かどうか
   */
  disabled?: boolean;

  /**
   * 読み取り専用かどうか
   */
  isReadonly?: boolean;

  /**
   * エラー
   */
  error?: boolean;

  /**
   * 有効な値
   */
  valid?: boolean;

  /**
   * アウトライン スタイルにするかどうか
   */
  isOutlined?: boolean;

  /**
   * 不確定(部分的)な選択かどうか
   */
  isIndeterminate?: boolean;

  /**
   * 横幅
   */
  width?: '3s' | '2s' | 's' | 'm' | 'ml' | 'l' | '2l' | 'full';
  /**
   * 高さ
   */
  height?: 's' | 'm' | 'l' | '2l' | '3l';

  /** key 連続するCheckbox要素の場合、特定するためのKey設定 React-warning対策 */
  key?: string | number;
}

const Checkbox: React.FC<CheckboxProps> = ({
  className,
  label = '',
  labelClassName,
  disabled = false,
  isReadonly = false,
  error = false,
  valid = false,
  isOutlined = false,
  isIndeterminate = false,
  width,
  height,
  id = _uniqueId('uc-checkbox-'),
  ...props
}) => {
  const classes = classNames(
    'uc-checkbox',
    className,
    width && `uc-checkbox--w${width === 'full' ? '-' : ''}${width}`,
    height && `uc-checkbox--h${height}`,
    disabled && 'uc-checkbox--disabled',
    isReadonly && 'uc-checkbox--readonly',
    error && 'uc-checkbox--error',
    valid && 'uc-checkbox--success',
    isOutlined && 'uc-checkbox--outlined',
    isIndeterminate && 'uc-checkbox--indeterminate',
    !label && 'uc-checkbox--no-text'
  );

  return (
    <div className={classes} key={props.key}>
      <input
        {...props}
        id={id}
        className='uc-checkbox__icon'
        type='checkbox'
        name='demo-checkbox-height'
        disabled={disabled || isReadonly}
      />
      <label htmlFor={id} className={classNames('uc-checkbox__label', labelClassName)}>
        {label}
      </label>
    </div>
  );
};

export default Checkbox;
